import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useI18n } from "../../../i18n/LanguageContext";
import { SITE } from "../../../content/site";

const NUMS = ["01", "02", "03", "04", "05", "06"];

export default function ProductionLayers() {
  const { lang } = useI18n();
  const hs = SITE[lang].homeStory || SITE.en.homeStory;
  const c = hs.production;
  const alt = (SITE[lang].events || SITE.en.events).alt;
  const [active, setActive] = useState(0);

  return (
    <section data-testid="home-production" className="relative overflow-hidden bg-[#050505]">
      <img src="/events/madrid.jpg" alt={alt.madrid} loading="lazy" width="1920" height="1283"
        className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/35" />

      <div className="relative z-10 mx-auto flex min-h-[100vh] max-w-[1400px] flex-col justify-center px-6 py-24 md:px-12 md:py-32">
        <p className="overline text-white/50">{c.overline}</p>
        <h2 className="font-display mt-7 max-w-3xl text-3xl font-light leading-[1.05] tracking-tightest text-white md:text-5xl">{c.title}</h2>
        <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-white/70 md:text-lg">{c.text}</p>

        <div className="mt-14 grid gap-10 lg:mt-20 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="mb-5 text-[11px] font-medium uppercase tracking-[0.3em] text-[#2aa08c]">{c.hint}</p>
            <div className="flex flex-col">
              {c.layers.map((l, i) => (
                <button
                  key={l.k}
                  data-testid={`production-layer-${i}`}
                  onMouseEnter={() => setActive(i)}
                  onClick={() => setActive(i)}
                  className={`group flex items-baseline gap-5 border-t border-white/12 py-4 text-left transition-colors ${
                    active === i ? "text-white" : "text-white/40 hover:text-white/70"
                  }`}
                >
                  <span className={`font-display text-xs tracking-[0.25em] ${active === i ? "text-[#2aa08c]" : "text-white/30"}`}>{NUMS[i]}</span>
                  <span className="font-display text-2xl font-light tracking-tight md:text-3xl">{l.k}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <div className="rounded-2xl border border-white/15 bg-black/45 p-8 backdrop-blur-md md:p-10 lg:min-h-[260px]">
              <AnimatePresence mode="wait">
                <motion.div
                  key={active}
                  initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
                  data-testid="production-layer-desc"
                >
                  <p className="font-display text-sm font-500 tracking-[0.3em] text-[#2aa08c]">{NUMS[active]}</p>
                  <h3 className="font-display mt-3 text-2xl font-light tracking-tight text-white md:text-3xl">{c.layers[active].k}</h3>
                  <p className="mt-4 text-base font-light leading-relaxed text-white/75 md:text-lg">{c.layers[active].d}</p>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
